import {
  Action_SaveKho,
  Action_SaveKhoSuccess,
  Action_SaveKhoFailed,
  Action_GetDanhSachKho,
  Action_GetDanhSachKhoSuccess,
  Action_GetChiTietKho,
  Action_GetChiTietKhoSuccess,
  Action_DeleteKho,
  Action_DeleteKhoSuccess,
  Action_DeleteKhoFailed,
  Action_LockUnlock,
  Action_LockUnlockSuccess,
  Action_LockUnlockFailed,
} from "./actionTypes";

// Sự kiện lưu kho
export const Index_SaveKho = (data) => ({
  type: Action_SaveKho,
  payload: data,
});
export const Index_SaveKhoSuccess = (data) => ({
  type: Action_SaveKhoSuccess,
  payload: data,
});
export const Index_SaveKhoFailed = (data) => ({
  type: Action_SaveKhoFailed,
  payload: data,
});

//Danh sách kho
export const Index_GetDanhSachKho = (data) => ({
  type: Action_GetDanhSachKho,
  payload: data,
});
export const Index_GetDanhSachKhoSuccess = (data) => ({
  type: Action_GetDanhSachKhoSuccess,
  payload: data,
});

//Chi tiết kho
export const Index_GetChiTietKho = (data) => ({
  type: Action_GetChiTietKho,
  payload: data,
});
export const Index_GetChiTietKhoSuccess = (data) => ({
  type: Action_GetChiTietKhoSuccess,
  payload: data,
});

// Sự kiện xóa kho
export const Index_DeleteKho = (data) => ({
  type: Action_DeleteKho,
  payload: data,
});
export const Index_DeleteKhoSuccess = (data) => ({
  type: Action_DeleteKhoSuccess,
  payload: data,
});
export const Index_DeleteKhoFailed = (data) => ({
  type: Action_DeleteKhoFailed,
  payload: data,
});

// Sự kiện khoá mở khoá kho
export const Index_LockUnlockKho = (data) => ({
  type: Action_LockUnlock,
  payload: data,
});
export const Index_LockUnlockKhoSuccess = (data) => ({
  type: Action_LockUnlockSuccess,
  payload: data,
});
export const Index_LockUnlockKhoFailed = (data) => ({
  type: Action_LockUnlockFailed,
  payload: data,
});
